import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServicePriceProps } from "apis";

export type ServicePriceState = ServicePriceProps;

const initialState: ServicePriceState = {
};
export const aboutSlice = createSlice({
    name: "service-price",
    initialState,
    reducers: {
        servicePriceUpdate: (
            state,
            action: PayloadAction<ServicePriceState>
        ) => {
            state.referenceNumber = action.payload.referenceNumber;
            state.summary = action.payload.summary;
            state.issueDate = action.payload.issueDate;
            state.issuingAgency = action.payload.issuingAgency;
            state.signer = action.payload.signer;
            state.description = action.payload.description;
            state.pdfUrl = action.payload.pdfUrl;
        }
    },
});

export const { servicePriceUpdate } = aboutSlice.actions;
export default aboutSlice.reducer;
